module.exports = __webpack_public_path__ + "img/00046.bc37e18d.webp";